export default{
  // 业务配置
  merchant_findMerchantByPage:{
    type: 'formDataPost'
  },
  merchant_add:{
    type:'post'
  },
  merchant_update:{
    type:'post'
  },
  merchant_delete:{
    type:'formDataPost'
  },
  merchant_find:{
    type:'formDataPost'
  },
  // 平台账号
  user_findAllByPage: {
    type: 'formDataPost'
  },
  merchant_findAll:{
    type:'formDataPost'
  },
  user_add:{
    type:'formDataPost'
  },
  user_update:{
    type:'formDataPost'
  },
  user_reSetPwd:{
    type:'formDataPost'
  },
  user_delete:{
    type:'formDataPost'
  },
  // 角色权限
  role_findAll:{
    type:'formDataPost'
  },
  role_findRoleByPage: {
    type: 'formDataPost'
  },
  module_getAll:{
    type:'formDataPost'
  },
  role_add:{
    type:'post'
  },
  role_delete:{
    type:'formDataPost'
  },
  module_getByRoleId:{
    type:'formDataPost'
  },
  role_update:{
    type:'post'
  },
  // 支付通道
  payVendor_findPayVendorByPage:{
    type:'formDataPost'
  },
  payVendor_findAll:{
    type:'formDataPost'
  },
  payVendor_add:{
    type:'formDataPost'
  },
  payVendor_update:{
    type:'formDataPost'
  },
  payVendor_delete:{
    type:'formDataPost'
  },
  // 收款通道
  receivePayVendor_findReceivePayVendorByPage:{
    type:'formDataPost'
  },
  receivePayVendor_findAll:{
    type:'formDataPost'
  },
  receivePayVendor_add:{
    type:'formDataPost'
  },
  receivePayVendor_update:{
    type:'formDataPost'
  },
  receivePayVendor_delete:{
    type:'formDataPost'
  },
  // 实名认证
  verifyVendor_findVerifyVendorByPage:{
    type:'formDataPost'
  },
  verifyVendor_findAll:{
    type:'formDataPost'
  },
  verifyVendor_add:{
    type:'formDataPost'
  },
  verifyVendor_update:{
    type:'formDataPost'
  },
  verifyVendor_delete:{
    type:'formDataPost'
  },
  merchantAccount_getOssStsToken: {
    type: 'formDataPost'
  },
  // 虚拟子账号
  merchantAccount_findMerchantAccountByPage:{
    type:'formDataPost'
  },
  merchantAccount_addMerchantAccount:{
    type:'formDataPost'
  },
  merchantAccount_updateMerchantAccount:{
    type:'formDataPost'
  },
  merchantAccount_deleteMerchantAccount:{
    type:'formDataPost'
  },
  merchantAccount_selectMerchantPayAccount:{
    type:'formDataPost'
  },
  merchantAccount_addMerchantPayAccountOperatorLog:{
    type:'post'
  },
  merchantAccount_selectMerchantPayAccountOperatorLog:{
    type:'post'
  }
}



// WEBPACK FOOTER //
// ./src/service/modules/systemConfig.js